// extracted by mini-css-extract-plugin
export var sliderRange = "_n0-2";
export var sliderRoot = "_n0-0";
export var sliderThumb = "_n0-3";
export var sliderTrack = "_n0-1";